import './App.css';
import Console from './components/Console';
import Footer from './components/Footer';
import Assistant from './components/Assistant';
import { useFrustrationSensor } from './components/Shortener/hooks/useFrustrationSensor';
import { MotionConfig } from 'framer-motion';

function App() {
  useFrustrationSensor();

  return (
    <MotionConfig reducedMotion="user">
      <div className="App">
        <Console />
        <Footer />
        <Assistant />
      </div>
    </MotionConfig>
  ); 
  
}

export default App;